import React, { useEffect, useState, useRef } from 'react';
import AsyncSelect from "react-select/async";
import { useNavigate } from "react-router-dom";
import { customFetch } from '../apiClient';
import CustomerBillingReceipt from './CustomerBillingReceipt';

// --- Initial States ---
const initialCustomer = {
  cid: 0,
  custName: "",
  mobileNo: "",
  cAddress: "",
  age: 0,
  hid: 0,
  gender: "",
  ipdId: null,
};

const initialServiceForm = {
  services: "",
  qty: 1,
  rate: 0,
  amount: 0,
};
const customSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '26px',
    height: '26px',
    fontSize: '11px',
    borderRadius: '4px',
    borderColor: state.isFocused ? 'var(--theme-color, #0088cc)' : '#cbd5e0',
    boxShadow: state.isFocused ? '0 0 0 2px color-mix(in srgb, var(--theme-color, #0088cc), transparent 85%)' : 'none',
    '&:hover': { borderColor: 'var(--theme-color, #0088cc)' },
    padding: '0'
  }),
  valueContainer: (base) => ({ ...base, padding: '0 6px', height: '24px' }),
  indicatorsContainer: (base) => ({ ...base, height: '24px' }),
  dropdownIndicator: (base) => ({ ...base, padding: '0 4px' }),
  clearIndicator: (base) => ({ ...base, padding: '0 4px' }),
  input: (base) => ({ ...base, margin: '0', padding: '0', fontSize: '11px' }),
  menu: (base) => ({ ...base, zIndex: 99999, borderRadius: '4px' }),
  menuPortal: (base) => ({ ...base, zIndex: 99999 }),
  option: (base, state) => ({
    ...base,
    fontSize: '11px',
    padding: '6px 10px',
    backgroundColor: state.isSelected 
      ? 'var(--theme-color, #0088cc)' 
      : state.isFocused 
        ? 'color-mix(in srgb, var(--theme-color, #0088cc), white 90%)' 
        : 'white',
    color: state.isSelected ? 'white' : '#333',
    cursor: 'pointer',
    '&:active': { backgroundColor: 'var(--theme-color, #0088cc)', color: 'white' }
  }),
  placeholder: (base) => ({ ...base, color: '#a0aec0', fontSize: '11px' })
};

const BillingForm = ({ onSubmitSuccess }) => {
  // --- States ---
  const [customer, setCustomer] = useState(initialCustomer);
  const [isExistingCustomer, setIsExistingCustomer] = useState(false);
  
  const [serviceForm, setServiceForm] = useState(initialServiceForm);
  const [addedServices, setAddedServices] = useState([]);
  
  // ✅ Payment States
  const [discountValue, setDiscountValue] = useState(""); // User Input
  const [discountType, setDiscountType] = useState("amount"); // "percent" or "amount"
  const [cash, setCash] = useState(""); 
  const [upi, setUpi] = useState("");   
  // --- States ---
const [customerType, setCustomerType] = useState("BILLING"); // Default: Direct Billing
  // Meta States
  const [savedBillData, setSavedBillData] = useState(null);
  const [disAuthority, setDisAuthority] = useState("");
  const [requestedBy, setRequestedBy] = useState("");
  const [companyDetails, setCompanyDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  
  // Edit Mode States
  const [editIndex, setEditIndex] = useState(null);
  const [editForm, setEditForm] = useState({ ...initialServiceForm });
  
  const token = sessionStorage.getItem("token");
  const navigate = useNavigate();
  
  // --- Refs ---
  const formRef = useRef(null);
  const serviceSelectWrapperRef = useRef(null);
  const qtyRef = useRef(null);
  const discountRef = useRef(null);

  // --- Dynamic Calculations (UI Display) ---
  const totalAmount = addedServices.reduce((sum, srv) => sum + Number(srv.amount), 0);
  
  // 🧮 Discount Calculation Logic
  const calculateDiscountAmount = () => {
      const val = Number(discountValue) || 0;
      if (discountType === "percent") {
          return (totalAmount * val) / 100;
      }
      return val; // If Amount, return directly
  };

  const finalDiscountAmount = calculateDiscountAmount();
  const payableUI = totalAmount - finalDiscountAmount;
  const receivedUI = (Number(cash) || 0) + (Number(upi) || 0);
  const dueUI = payableUI - receivedUI;

  // --- Effects ---
  useEffect(() => {
    if (success) { const t = setTimeout(() => setSuccess(""), 4000); return () => clearTimeout(t); }
  }, [success]);

  useEffect(() => {
    if (error) { const t = setTimeout(() => setError(""), 5000); return () => clearTimeout(t); }
  }, [error]);

  useEffect(() => {
    setTimeout(() => {
       const input = document.querySelector('.patient-search-select input');
       if(input) input.focus();
    }, 300);
  }, []);

  useEffect(() => {
    const hospitalId = sessionStorage.getItem("hospitalId");
    if (hospitalId) {
     customFetch(`/Company/${hospitalId}`)
        .then(res => res.json()).then(data => setCompanyDetails(data)).catch(console.error);
    }
  }, [token]);

  // --- API Loaders ---
  // const loadCustomerOptions = async (inputValue) => {
  //   if (!inputValue) return [];
  //   try {
  //     const res = await fetch(`${API_BASE}/Billing/search-customer?search=${encodeURIComponent(inputValue)}`, { headers: { Authorization: `Bearer ${token}` } });
  //     if (!res.ok) return [];
  //     const data = await res.json();
  //     return data.map((c) => ({ label: `${c.custName} (${c.mobileNo})`, value: c.cid, data: c }));
  //   } catch { return []; }
  // };


// --- API Loaders ---
 // --- API Loaders ---
  const loadCustomerOptions = async (inputValue) => {
    if (!inputValue || inputValue.length < 2) return [];

    let url = "";
    
    if (customerType === "BILLING") {
    url = `/Billing/search-customer?search=${encodeURIComponent(inputValue)}`;
} else if (customerType === "OPD") {
    url = `/MediCustDT/searchopd?term=${encodeURIComponent(inputValue)}`;
} else if (customerType === "IPD") {
    url = `/MediCustDT/searchipd?term=${encodeURIComponent(inputValue)}`;
}

try {
    const res = await customFetch(url);
      if (!res.ok) return [];
      const data = await res.json();

      // 2. Data Mapping
      return data.map((item) => {
        let label = "";
        let standardizedData = {};

        if (customerType === "BILLING") {
            // Existing Billing Customer
            label = `${item.custName} (${item.mobileNo})`;
            standardizedData = {
                cid: item.cid, 
                custName: item.custName,
                mobileNo: item.mobileNo,
                cAddress: item.cAddress,
                age: item.age,
                uhid: item.uhid || "", 
                gender: item.gender || "",
               customerType: "BILLING",
               
            };
        } else {
            // OPD / IPD Customer (Mapping based on your console log)
            // Your API returns: name, uhidNo, mobileNo, address, age, gender, id
            
            label = `${item.name} | UHID: ${item.uhidNo} | ${item.mobileNo}`;
            
            standardizedData = {
                cid: 0, // 0 is important so backend creates/links a new Billing Customer entry
                custName: item.name,       // ✅ Fixed: Matches your API
                mobileNo: item.mobileNo,   // ✅ Fixed
                cAddress: item.address || "", 
                age: item.age || 0,
                uhid: item.uhidNo,         // ✅ Fixed: Matches 'uhidNo'
               gender: item.gender || item.Gender || "Male",
                customerType: customerType, // "OPD" or "IPD"
                ipdId: customerType === "IPD" ? (item.id || item.ipdId) : null
            };
        }

        return { 
            label: label, 
            value: standardizedData.uhid || standardizedData.cid, 
            data: standardizedData 
        };
      });

    } catch (err) { 
        console.error(err);
        return []; 
    }
  };

 const loadServiceOptions = async (inputValue) => {
    try {
      const res = await customFetch(`/ChargeMaster/list?search=${encodeURIComponent(inputValue)}&type=BILLING`);
        
        if (!res.ok) return [];
        const data = await res.json();

        // ✅ Ab filter() ki zarurat NAHI hai, kyunki backend ne sirf BILLING hi bheja hai
        return data.map((srv) => ({ 
            label: srv.chargeName, 
            value: srv.srno, 
            amount: srv.amount || 0, 
            unit: srv.unit 
        }));
    } catch (err) {
        console.error("Service Load Error:", err);
        return [];
    }
};
  // --- Keyboard Navigation ---
  const handleGlobalKeyDown = (e) => {
    if (e.target.closest('.service-search-container')) {
        const inputVal = e.target.value;
        if (e.key === 'Enter') {
            if (!inputVal && !serviceForm.services) {
                e.preventDefault();
                discountRef.current?.focus();
                return;
            }
            return; 
        }
    }

    const focusable = formRef.current.querySelectorAll(
      'input:not([disabled]):not([readonly]):not([type="hidden"]), ' +
      'select:not([disabled]), ' +
      'button:not([disabled]):not(.btn-list):not(.btn-icon), ' +
      'textarea:not([disabled])'
    );
    
    if (!focusable.length) return;
    const elementsArr = Array.from(focusable);
    const activeIndex = elementsArr.indexOf(document.activeElement);

    if (e.key === 'Enter') {
        if (!document.activeElement.classList.contains('btn-submit')) {
             e.preventDefault(); 
        }
        if (document.activeElement.classList.contains('btn-add-service')) {
            handleAddService();
            return;
        }
        if (document.activeElement.classList.contains('btn-submit')) {
            return;
        }
        const nextIndex = activeIndex + 1;
        if (nextIndex < elementsArr.length) {
            elementsArr[nextIndex].focus();
            if (elementsArr[nextIndex].tagName === 'INPUT') {
                elementsArr[nextIndex].select(); 
            }
        }
    }
  };

  useEffect(() => {
    const handler = (e) => {
        if (formRef.current && formRef.current.contains(e.target)) {
            handleGlobalKeyDown(e);
        }
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [serviceForm.services]);

  // --- Handlers ---
 const handleCustomerSelect = (selected) => {
    if (!selected) {
      setCustomer({ ...initialCustomer, customerType: customerType }); // Reset but keep type
      setIsExistingCustomer(false);
      return;
    }
    
    // Mapping already loadOptions me ho chuki hai
    setCustomer({
        ...selected.data, // Pura object spread kar do
        cid: selected.data.cid || 0 // Ensure CID is handled
    });
    
    setIsExistingCustomer(true);
    setSuccess("Customer details loaded!");
    
    // Focus logic...
    setTimeout(() => {
        const input = serviceSelectWrapperRef.current?.querySelector('input');
        input?.focus();
    }, 100);
  };
  const handleServiceChange = (selectedOption) => {
    if (!selectedOption) {
      setServiceForm(initialServiceForm);
      return;
    }
    setServiceForm({
      services: selectedOption.label,
      qty: 1,
      rate: selectedOption.amount || 0,
      amount: (selectedOption.amount || 0).toFixed(2),
    });
    setTimeout(() => {
        qtyRef.current?.focus();
        qtyRef.current?.select();
    }, 100);
  };

  const handleCustomerChange = (e) => {
    const { name, value } = e.target;
    setCustomer((prev) => ({ ...prev, [name]: value }));
  };

  const handleServiceFormChange = (e) => {
    const { name, value } = e.target;
    setServiceForm((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    const qtyNum = parseFloat(serviceForm.qty) || 0;
    const rateNum = parseFloat(serviceForm.rate) || 0;
    setServiceForm((prev) => ({
      ...prev,
      amount: (qtyNum * rateNum).toFixed(2),
    }));
  }, [serviceForm.qty, serviceForm.rate]);

  const handleAddService = () => {
    if (!serviceForm.services) { setError("Please select a service."); return; }
    if (!serviceForm.qty || Number(serviceForm.qty) <= 0) { setError("Quantity > 0 required."); return; }
    setError("");

    const newService = {
      services: serviceForm.services,
      qty: Number(serviceForm.qty),
      rate: Number(serviceForm.rate),
      amount: Number(serviceForm.amount),
    };

    setAddedServices((prev) => [...prev, newService]);
    setServiceForm(initialServiceForm);
    setSuccess("Service added!");
    setTimeout(() => {
        const input = serviceSelectWrapperRef.current?.querySelector('input');
        input?.focus();
    }, 100);
  };

  const handleEditClick = (index) => { setEditIndex(index); setEditForm({ ...addedServices[index] }); };
  
  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => {
        const up = { ...prev, [name]: value };
        if (name === "qty" || name === "rate") up.amount = ((parseFloat(up.qty)||0) * (parseFloat(up.rate)||0)).toFixed(2);
        return up;
    });
  };
  
  const handleSaveEdit = () => {
    setAddedServices(prev => prev.map((s, i) => i === editIndex ? { ...s, qty: Number(editForm.qty), rate: Number(editForm.rate), amount: Number(editForm.amount) } : s));
    setEditIndex(null); setEditForm(initialServiceForm);
  };
  
  const handleRemoveService = (i) => setAddedServices(prev => prev.filter((_, idx) => idx !== i));

  // --- ✅ FINAL SUBMIT HANDLER ---
  const handleSubmit = async (e) => {
    e.preventDefault(); 

    if (!customer.custName.trim() || !customer.mobileNo.trim()) { setError("Customer Name & Mobile required."); return; }
    if (addedServices.length === 0) { setError("Add at least one service."); return; }

    setError(""); setSuccess(""); setLoading(true);
    
    // 1. Calculate final values inside Submit (to avoid 0 issue)
    const currentTotal = addedServices.reduce((sum, srv) => sum + Number(srv.amount), 0);
    
    const userDisValue = Number(discountValue) || 0;
    let finalDisAmount = 0;

    // 🧮 Logic: Convert to Amount if Percent
    if (discountType === "percent") {
        finalDisAmount = (currentTotal * userDisValue) / 100;
    } else {
        finalDisAmount = userDisValue;
    }
    
    const currentCash = Number(cash) || 0;
    const currentUpi = Number(upi) || 0;
    const currentReceived = currentCash + currentUpi;
    
    const currentPayable = currentTotal - finalDisAmount;
    const currentDue = currentPayable - currentReceived;

    const payload = {
        customer: { 
            cid: customer.cid || 0, 
            custName: customer.custName, 
            mobileNo: customer.mobileNo, 
            cAddress: customer.cAddress || "", 
            age: Number(customer.age) || 0,
            hid: customer.hid || 0 ,
            uhid: customer.uhid || "", 
          customerType: customerType || "BILLING",
          gender: customer.gender,
        },
        summary: { 
            billNo: "", 
            total: currentTotal, 
            dis: finalDisAmount, // ✅ Always sending Amount to Backend
            received: currentReceived, 
            cash: currentCash, 
            upi: currentUpi, 
            due: currentDue, 
            billDate: null, 
            disAuthority: disAuthority || "", 
            requestedBy: requestedBy || "",
            ipdId: customer.ipdId || null
        },
        details: addedServices.map(s => ({ 
            services: s.services, 
            qty: Number(s.qty) || 0, 
            rate: Number(s.rate) || 0, 
            amount: Number(s.amount) || 0 
        })),
        payments: [] 
    };

    console.log("PAYLOAD:", payload);

    try {
     const res = await customFetch('/BillingTransaction/SaveBilling', {
    method: "POST", 
    body: JSON.stringify(payload)
});

      if (!res.ok) throw new Error(await res.text());
      
      const resData = await res.json();
      setSavedBillData(resData); 
      setSuccess("Bill generated!");
      
      // Reset
      setCustomer(initialCustomer); 
      setAddedServices([]); 
      setServiceForm(initialServiceForm); 
      setDiscountValue(""); // Reset
      setCash(""); 
      setUpi(""); 
      setDisAuthority(""); 
      setRequestedBy(""); 
      setIsExistingCustomer(false);
      
      if (onSubmitSuccess) onSubmitSuccess();
      setTimeout(() => { document.querySelector('.patient-search-select input')?.focus(); }, 500);

    } catch (err) { setError(err.message || "Error occurred"); } finally { setLoading(false); }
  };

  const handleGoToBillingList = () => navigate("/BillList");

  return (
    <>
      <div className="billing-container">
        <div className="billing-card">
          <div className="billing-header">
            <div className="header-left">
              <div className="header-icon"><i className="bi bi-receipt"></i></div>
              <div className="header-text"><h5>Customer Billing</h5><p>Create and manage customer bills</p></div>
            </div>
            <button type="button" onClick={handleGoToBillingList} className="btn-list" title="Go to Billing List"><i className="bi bi-list-ul"></i></button>
          </div>

          <div className="card-content">
            {error && <div className="alert-custom alert-danger slide-in"><span>{error}</span></div>}
            {success && <div className="alert-custom alert-success slide-in"><span>{success}</span></div>}

            <form ref={formRef} onSubmit={handleSubmit}>
              {/* Customer Search */}
              <div className="form-section">
  <div className="section-title">
    <i className="bi bi-search"></i>
    <span> Customer Details</span>
  </div>
  
<div className="section-content">
  
  {/* 1️⃣ Radio Buttons (Type Selection) - ये ज़रूरी है */}
  <div className="mb-2 d-flex gap-3 border-bottom pb-2">
    <div className="form-check">
        <input className="form-check-input" type="radio" name="ctype" id="type1" value="BILLING" checked={customerType === "BILLING"} onChange={(e) => { setCustomerType("BILLING"); setCustomer(initialCustomer); }} />
        <label className="form-check-label fw-bold" htmlFor="type1">Direct Billing</label>
    </div>
    <div className="form-check">
        <input className="form-check-input" type="radio" name="ctype" id="type2" value="OPD" checked={customerType === "OPD"} onChange={(e) => { setCustomerType("OPD"); setCustomer(initialCustomer); }} />
        <label className="form-check-label fw-bold text-primary" htmlFor="type2">OPD Patient</label>
    </div>
    <div className="form-check">
        <input className="form-check-input" type="radio" name="ctype" id="type3" value="IPD" checked={customerType === "IPD"} onChange={(e) => { setCustomerType("IPD"); setCustomer(initialCustomer); }} />
        <label className="form-check-label fw-bold text-success" htmlFor="type3">IPD Patient</label>
    </div>
  </div>

  {/* 2️⃣ Single Line Layout (7 Columns) */}
  <div className="form-row seven-col">
    
    {/* Search Field */}
    <div className="form-group patient-search-select"> {/* Class zaroori hai auto-focus ke liye */}
      <label className="form-label">Search {customerType}</label>
      <AsyncSelect 
        key={customerType} 
        cacheOptions 
        loadOptions={loadCustomerOptions} 
        onChange={handleCustomerSelect} 
        placeholder={`Search...`} 
        isClearable 
        styles={customSelectStyles} 
        // 👇 Ye line missing thi, iske bina search box me naam nahi dikhega select karne ke baad
        value={customer.custName ? { label: customer.custName, value: customer.cid } : null}
      />
    </div>

    {/* UHID (Small) */}
    <div className="form-group">
      <label className="form-label">UHID</label>
      <input type="text" value={customer.uhid || ""} className="form-input readonly" readOnly placeholder="N/A" />
    </div>

    {/* Name */}
    <div className="form-group">
      <label className="form-label">Name <span className="required">*</span></label>
      <input type="text" name="custName" value={customer.custName} onChange={handleCustomerChange} className="form-input" required placeholder="Name" />
    </div>

    {/* Mobile */}
    <div className="form-group">
      <label className="form-label">Mobile <span className="required">*</span></label>
      <input type="text" name="mobileNo" value={customer.mobileNo} onChange={handleCustomerChange} className="form-input" maxLength={10} required placeholder="Mobile" />
    </div>

    {/* Age */}
    <div className="form-group">
      <label className="form-label">Age <span className="required">*</span></label>
      <input type="number" name="age" value={customer.age || ""} onChange={handleCustomerChange} className="form-input" min="0" required placeholder="0" />
    </div>

    {/* Gender */}
    <div className="form-group">
      <label className="form-label">Gender <span className="required">*</span></label>
      <select name="gender" value={customer.gender || ""} onChange={handleCustomerChange} className="form-input" required>
        <option value="">Select</option>
        <option value="Male">Male</option>
        <option value="Female">Female</option>
        <option value="Other">Other</option>
      </select>
    </div>

    {/* Address */}
    <div className="form-group">
      <label className="form-label">Address</label>
      <input type="text" name="cAddress" value={customer.cAddress} onChange={handleCustomerChange} className="form-input" maxLength={100} placeholder="Address" />
    </div>

  </div>
</div>
</div>

              {/* Service Selection */}
              <div className="form-section">
                <div className="section-title"><i className="bi bi-cart-plus"></i><span>Add Services</span></div>
                <div className="section-content">
                  <div className="form-row four-col">
                    <div className="form-group service-search-container" ref={serviceSelectWrapperRef}>
                      <label className="form-label">Search Services <span className="required">*</span></label>
                      <AsyncSelect cacheOptions loadOptions={loadServiceOptions} onChange={handleServiceChange} placeholder="Search service..." isClearable styles={customSelectStyles} value={serviceForm.services ? { label: serviceForm.services, value: null } : null} />
                      <small className="text-muted d-block mt-1" style={{fontSize:'10px'}}>Press Enter on empty field to skip to billing</small>
                    </div>
                    <div className="form-group"><label className="form-label">Quantity</label><input ref={qtyRef} type="number" name="qty" value={serviceForm.qty} onChange={handleServiceFormChange} className="form-input" min="1" /></div>
                    <div className="form-group"><label className="form-label">Rate</label><input type="number" name="rate" value={serviceForm.rate} onChange={handleServiceFormChange} className="form-input" min="0" step="0.01" /></div>
                    <div className="form-group"><label className="form-label">Amount</label><input type="number" name="amount" value={serviceForm.amount} readOnly className="form-input readonly" /></div>
                  </div>
                  <div className="text-end">
                    <button type="button" className="btn-add-service" onClick={handleAddService} disabled={!serviceForm.services}><i className="bi bi-plus-circle"></i> Add Service</button>
                  </div>
                  {addedServices.length > 0 && (
                    <div className="table-wrapper">
                      <table className="services-table">
                        <thead><tr><th >Service</th><th className="text-center">Qty</th><th className="text-right">Rate</th><th className="text-right">Amount</th><th className="text-center">Action</th></tr></thead>
                        <tbody>
                          {addedServices.map((srv, idx) => (
                            <tr key={idx}>
                              {editIndex === idx ? (
                                <>
                                  <td><input type="text" name="services" value={editForm.services} className="table-input" readOnly /></td>
                                  <td><input type="number" name="qty" value={editForm.qty} onChange={handleEditFormChange} className="table-input" min="1" /></td>
                                  <td><input type="number" name="rate" value={editForm.rate} onChange={handleEditFormChange} className="table-input" step="0.01" min="0" /></td>
                                  <td><input type="number" name="amount" value={editForm.amount} readOnly className="table-input readonly" /></td>
                                  <td className="text-center"><button type="button" className="btn-icon btn-save" onClick={handleSaveEdit}><i className="bi bi-check-lg"></i></button></td>
                                </>
                              ) : (
                                <>
                                  <td>{srv.services}</td><td className="text-center">{srv.qty}</td><td className="text-right">₹{srv.rate.toFixed(2)}</td><td className="text-right fw-medium">₹{srv.amount.toFixed(2)}</td>
                                  <td className="text-center"><button type="button" className="btn-icon btn-edit" onClick={() => handleEditClick(idx)}><i className="bi bi-pencil"></i></button><button type="button" className="btn-icon btn-delete" onClick={() => handleRemoveService(idx)}><i className="bi bi-trash"></i></button></td>
                                </>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>

              {/* Billing Summary */}
              {addedServices.length > 0 && (
                <div className="form-section summary-section">
                  <div className="section-title"><i className="bi bi-calculator"></i><span>Billing Summary</span></div>
                  <div className="section-content">
                    <div className="form-row four-col">
                      <div className="form-group"><label className="form-label">Total Amount</label><input type="number" value={totalAmount.toFixed(2)} className="form-input readonly total-field" readOnly /></div>
                      
                      {/* ✅ Discount Toggle UI  */}
                      <div className="form-group">
                        <label className="form-label">Discount</label>
                        <div className="d-flex">
                            <select 
                                className="form-input" 
                              
                                value={discountType}
                                 style={{width: '60px', borderRight: 'none', borderRadius: '4px 0 0 4px', padding: '4px'}}
                                onChange={(e) => setDiscountType(e.target.value)}
                            >
                               <option value="amount">₹</option>
                                <option value="percent">%</option>
                               
                            </select>
                            <input 
                                ref={discountRef} 
                                type="number" 
                                min="0" 
                                value={discountValue} 
                                onChange={(e) => setDiscountValue(e.target.value)} 
                                placeholder="0" 
                                className="form-input" 
                                style={{borderRadius: '0 6px 6px 0', flex: 1}}
                            />
                        </div>
                      </div>
                      
                      <div className="form-group"><label className="form-label">Payable Amount</label><input type="number" value={payableUI.toFixed(2)} className="form-input readonly payable-field" readOnly /></div>
                      <div className="form-group"><label className="form-label">Due Amount</label><input type="number" value={dueUI.toFixed(2)} className="form-input readonly due-field" readOnly /></div>
                    </div>
                    <div className="form-row four-col">
                      <div className="form-group">
                        <label className="form-label">Cash</label>
                        <input type="number" min="0" value={cash} onChange={(e) => setCash(e.target.value)} placeholder="0.00" className="form-input" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">UPI</label>
                        <input type="number" min="0" value={upi} onChange={(e) => setUpi(e.target.value)} placeholder="0.00" className="form-input" />
                      </div>
                      <div className="form-group"><label className="form-label">Received</label><input type="number" value={receivedUI.toFixed(2)} className="form-input readonly" readOnly /></div>
                      <div className="form-group"><label className="form-label">Prepared By</label><input type="text" value={requestedBy} onChange={(e) => setRequestedBy(e.target.value)} placeholder="Name" className="form-input" /></div>
                    </div>
                    <div className="form-row"><div className="form-group"><label className="form-label">Authority</label><input type="text" value={disAuthority} onChange={(e) => setDisAuthority(e.target.value)} placeholder="Authorized by" className="form-input" /></div></div>
                  </div>
                </div>
              )}

              <div className="form-footer"><button type="submit" className="btn-submit" disabled={loading || addedServices.length === 0 || !customer.custName}><i className="bi bi-check-circle"></i> Generate Bill</button></div>
            </form>
          </div>
        </div>
      </div>
      <CustomerBillingReceipt show={!!savedBillData} receiptData={savedBillData} companyDetails={companyDetails} onClose={() => setSavedBillData(null)} onPrint={() => window.print()} />

     {/* STYLES */}
      <style jsx>{`
        *, *::before, *::after { box-sizing: border-box; }
        .billing-container { padding: 0; font-family: system-ui, sans-serif; }
        .billing-card { background: white; border-radius: 6px; box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06); border: 1px solid #e0e6ed; overflow: visible; }
        
        /* HEADER */
        .billing-header { background: var(--theme-color, #0088cc); padding: 6px 12px; border-radius: 6px 6px 0 0; border-bottom: 2px solid rgba(0,0,0,0.1); display: flex; justify-content: space-between; align-items: center; }
        .header-left { display: flex; align-items: center; gap: 6px; color: white; }
        .header-icon { font-size: 14px; display: flex; align-items: center; }
        .header-text { display: flex; align-items: baseline; gap: 8px; }
        .header-text h5 { margin: 0; font-size: 13px; font-weight: 600; }
        .header-text p { margin: 0; font-size: 10px; opacity: 0.8; }
        .btn-list { width: 24px; height: 24px; background: rgba(255, 255, 255, 0.2); border: none; border-radius: 4px; color: white; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: all 0.2s; font-size: 13px; }
        .btn-list:hover { background: rgba(255, 255, 255, 0.3); }
        
        .card-content { padding: 10px 12px; }
        
        /* ALERTS */
        .alert-custom { padding: 6px 10px; border-radius: 4px; font-size: 11px; margin-bottom: 10px; display: flex; align-items: center; gap: 6px; font-weight: 500; }
        .alert-danger { background: #fee2e2; color: #b91c1c; border: 1px solid #fecaca; }
        .alert-success { background: #dcfce7; color: #15803d; border: 1px solid #bbf7d0; }
        
        /* SECTIONS */
        .form-section { background: #f8f9fa; border: 1px solid #e0e6ed; border-radius: 5px; margin-bottom: 10px; overflow: visible; }
        .section-title { background: var(--theme-color, #0088cc); padding: 5px 10px; display: flex; align-items: center; gap: 5px; border-radius: 4px 4px 0 0; color: white; font-size: 11px; font-weight: 600; }
        .section-content { padding: 8px 10px; background: white; border-radius: 0 0 5px 5px; }
        
        /* GRID & LAYOUT */
        .form-row { display: grid; gap: 8px; margin-bottom: 8px; align-items: start; }
        .form-row:last-child { margin-bottom: 0; }
        .form-row.three-col { grid-template-columns: repeat(3, 1fr); }
        .form-row.four-col { grid-template-columns: repeat(4, 1fr); }
        .form-row.seven-col { grid-template-columns: 2fr 1fr 2fr 1.5fr 1fr 1fr 2fr; gap: 8px; }
        .form-group { display: flex; flex-direction: column; }
        .form-label { font-size: 10px; font-weight: 600; color: #2c3e50; margin-bottom: 2px; }
        .required { color: #dc2626; }
        
        /* INPUTS & SELECTS */
        .form-input, .table-input { height: 26px; min-height: 26px; padding: 2px 6px; border: 1px solid #cbd5e0; border-radius: 4px; font-size: 11px; color: #2c3e50; transition: none; outline: none; width: 100%; }
        .form-input:focus, .table-input:focus { border-color: var(--theme-color, #0088cc); box-shadow: 0 0 0 2px rgba(0,136,204,0.15); }
        .form-input.readonly { background: #f3f4f6; color: #6c757d; cursor: not-allowed; }
        .form-check-label { font-size: 11px; margin-left: 4px; }
        .form-check-input { margin-top: 2px; }
        
        /* BUTTONS */
        .btn-add-service { height: 26px; padding: 0 12px; border-radius: 4px; border: none; background: var(--theme-color, #0088cc); color: white; font-size: 11px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 4px; }
        .btn-add-service:hover:not(:disabled) { opacity: 0.9; }
        .btn-add-service:disabled { opacity: 0.5; cursor: not-allowed; }
        
        .btn-icon { width: 22px; height: 22px; padding: 0; display: inline-flex; align-items: center; justify-content: center; border-radius: 3px; border: none; cursor: pointer; margin: 0 2px; font-size: 11px; }
        .btn-edit { background: #e0f2fe; color: #0284c7; }
        .btn-edit:hover { background: #0284c7; color: white; }
        .btn-delete { background: #fee2e2; color: #dc2626; }
        .btn-delete:hover { background: #dc2626; color: white; }
        .btn-save { background: #dcfce7; color: #15803d; }
        .btn-save:hover { background: #15803d; color: white; }
        
        .form-footer { margin-top: 10px; padding-top: 10px; border-top: 1px solid #e0e6ed; text-align: right; }
        .btn-submit { height: 26px; padding: 0 16px; border-radius: 4px; border: none; background: #15803d; color: white; font-size: 11px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; }
        .btn-submit:hover:not(:disabled) { background: #166534; }
        
        /* TABLES */
        .table-wrapper { overflow-x: auto; border-radius: 4px; border: 1px solid #e0e6ed; margin-top: 8px; }
        .services-table { width: 100%; border-collapse: collapse; font-size: 11px; }
        .services-table thead { background: #f1f5f9; border-bottom: 1px solid #cbd5e0; }
        .services-table th { color: #2c3e50; font-weight: 600; padding: 6px 8px; font-size: 10px; text-align: left; border: 1px solid #e0e6ed; text-transform: uppercase; white-space: nowrap; }
        .services-table tbody tr { border-bottom: 1px solid #e0e6ed; }
        .services-table tbody tr:hover { background: #f8fafc; }
        .services-table tbody td { padding: 4px 8px; border-right: 1px solid #e0e6ed; vertical-align: middle; }
        .services-table tbody td:last-child { border-right: none; }
        
        .table-input { background: transparent; border: 1px solid transparent; height: 22px; min-height: 22px; padding: 0 4px; }
        .table-input:focus { background: white; border-color: var(--theme-color, #0088cc); }
        
        /* UTILS */
        .text-center { text-align: center !important; }
        .text-right { text-align: right !important; }
        .fw-medium { font-weight: 600; }
        .text-primary { color: var(--theme-color, #0088cc) !important; }
        .text-success { color: #15803d !important; }
        .text-muted { color: #64748b !important; }
        
        .span-2 { grid-column: span 2; } 
        .span-3 { grid-column: span 3; } 
        .span-full { grid-column: 1 / -1; } 
        
        @media (max-width: 992px) {
          .form-row.seven-col { grid-template-columns: repeat(2, 1fr); }
        }
        @media (max-width: 768px) { 
          .form-row.three-col, .form-row.four-col, .form-row.seven-col { grid-template-columns: 1fr; } 
          .span-2, .span-3, .span-full { grid-column: span 1; }
          .btn-submit { width: 100%; justify-content: center; } 
        }
      `}</style>
    </>
  );
};

export default BillingForm;